export default __webpack_public_path__ + "static/media/favicon-ok.21cc9cb3.ico";